import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '启航2021·全国两会特别报道';
const baseUrl = '2021-national-lianghui-report-h5';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'live-list',
      name: `${baseUrl}-live-list`,
      component: () => import('./pages/LiveList.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
